import React, { Component, Fragment } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ModalFooter, Button, ModalBody } from 'reactstrap';
import { get } from 'lodash';
import { Formik } from 'formik';
import * as Yup from 'yup';


import {
  getCreateTemplateUrl, displayToaster, hideToaster, toggleDrawer,
  getCompanyDocCategories, GET_COMPANY_DOCUMENT_CATEGORIES, pushRecentDocCategory,
  uploadCompanyDocument, UPLOAD_COMPANY_DOCUMENT, LOADING_PROP_TYPE,
  uploadSimpleSignatureRequest, UPLOAD_SIMPLE_SIGNATURE_REQUEST, GET_UPLOAD_URL,
} from '../../modules/index';
import {
  UploadTemplate, TemplateType, TemplateHelp, SubmitButton,
  CenteredModal, ExitConfirmationModal, HellosignContainer,
} from '../../components';
import { APPLICATION_ROOT, MAX_DOC_CATEGORY_LENGTH } from '../../constants';
import { esignProductTierNames } from '../../constants/esignProductTierNames';

const DEFAULT_STATE = {
  file: undefined,
  drawerClasses: ['drawer'],
  helloSignClient: undefined,
  category: undefined,
  title: undefined,
  esignOn: false,
  creationStep: 'uploadTemplate',
  buttonText: 'NEXT',
  buttonTextUpdating: 'NEXT',
  readyToContinue: false,
  uploadTemplateValues: undefined,
  templateTypeValue: 'noSign',
  confirmationModalIsOpen: false,
  handleFormReset: undefined,
  helloSignDrawerOpen: false,
};

const uploadSchema = Yup.object().shape({
  category: Yup.string().max(MAX_DOC_CATEGORY_LENGTH, 'CATEGORY_CANNOT_EXCEED_50_CHARACTERS'),
  title: Yup.string().required('PLEASE_SPECIFY_A_TITLE'),
});

class CreateTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;

    this.onUpload = this.onUpload.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.resetTemplateState = this.resetTemplateState.bind(this);
  }

  componentDidMount() {
    this.props.getDocCategoryList();
  }

  componentDidUpdate(prevProps) {
    const { loading, esignDocs: { results } } = this.props;
    const { loading: prevLoading } = prevProps;
    if (prevLoading[UPLOAD_SIMPLE_SIGNATURE_REQUEST] === 'loading' && loading[UPLOAD_SIMPLE_SIGNATURE_REQUEST] === 'complete') {
      const { file: { file: { path: fileName } } } = this.state;
      this.props.displayToaster([
        'success',
        <FormattedMessage id="SUCCESSFULLY_UPLOADED" values={{ fileName }} defaultMessage="FILE_UPLOADED" />,
        'app',
        5000,
        true,
      ]);
      this.onClose(false);
    }
    if (prevLoading[UPLOAD_COMPANY_DOCUMENT] === 'loading' && loading[UPLOAD_COMPANY_DOCUMENT] === 'complete') {
      const [{ fileName }] = results;
      this.props.displayToaster([
        'success',
        <FormattedMessage id="SUCCESSFULLY_UPLOADED" values={{ fileName }} defaultMessage="FILE_UPLOADED" />,
        'app',
        5000,
        true,
      ]);
      this.onClose(false);
    }
  }

  onSubmit(values) {
    const { companyId } = get(window, 'asure.appSettings.selectedCompany');
    const { creationStep, uploadTemplateValues } = this.state;
    // the functionality of the button is dependent on which step we're on, which we can determine with the value of the button label
    if (creationStep === 'uploadTemplate') {
      this.setState({ uploadTemplateValues: values });
      this.setState({ creationStep: 'templateType' });
    } else {
      this.onUpload(
        companyId || uploadTemplateValues.companyId,
        uploadTemplateValues.category,
        uploadTemplateValues.title,
        this.state.isVisible,
        this.state.templateTypeValue,
        false,
      );
    }
  }

  onUpload(companyId, category = '', title, isPublishedToEmployee, documentType) {
    const { state } = this;
    const { file } = state;
    if (documentType === 'helloSign') {
      this.setState({
        ...state,
        category,
        title,
      }, () => {
        this.props.toggle();
        this.toggleHelloSignDrawer();
        if (category) {
          this.props.pushRecentDocCategory({ value: category, label: category });
        }
        this.props.getCreateTemplateUrl(file, companyId, category, title);
        this.props.hideToaster('app');
      });
    } else if (documentType === 'simpleSign') {
      file.title = title;
      if (category) {
        this.props.pushRecentDocCategory({ value: category, label: category });
      }
      this.props.uploadSimpleSignatureRequest(file, companyId, category);
    } else {
      file.title = title;
      if (category) {
        this.props.pushRecentDocCategory({ value: category, label: category });
      }
      this.props.uploadCompanyDocument(file, companyId, category, isPublishedToEmployee);
    }
  }

  onDrop(file) {
    this.setState({ file });
  }

  onClose(openConfirmDialogue = true) {
    if (openConfirmDialogue) {
      this.setState({ confirmationModalIsOpen: true });
    } else {
      this.props.toggle();
      setTimeout(() => this.setState(DEFAULT_STATE), 500);
    }
  }

  loadMoreCategories() {
    const { docCategories: { next } } = this.props;
    if (next && this.props.loading[GET_COMPANY_DOCUMENT_CATEGORIES] === 'complete') {
      this.props.getDocCategoryList(next);
    }
  }

  groupCategories = (docCategories) => {
    const clearCategory = { label: '   ', value: '' };
    const { recent, categories } = docCategories;
    return [
      { label: 'RECENT', options: recent },
      { label: 'CATEGORIES', options: [clearCategory, ...categories] },
    ];
  };

  closeConfirmationModal(quitTemplateCreation) {
    this.setState({ confirmationModalIsOpen: false });
    if (quitTemplateCreation) {
      this.onClose(false);
    }
  }

  updateButtonLabel(newButtonText, newSubmittingText) {
    this.setState({ buttonText: newButtonText });
    if (newSubmittingText) {
      this.setState({ buttonTextUpdating: newSubmittingText });
    } else {
      this.setState({ buttonTextUpdating: newButtonText });
    }
  }

  updateTemplateTypeValue(newValue) {
    this.setState({ templateTypeValue: newValue });
  }

  toggleHelloSignDrawer() {
    this.setState({ helloSignDrawerOpen: !this.state.helloSignDrawerOpen });
  }

  toggleHelpModal(close) {
    if (close) {
      this.setState({ creationStep: 'templateType' });
    } else {
      this.setState({ creationStep: 'helpMeChoose' });
    }
  }

  modalContent(values, errors, touched) {
    const {
      file,
      creationStep,
    } = this.state;
    const {
      loading,
      isDirectClient,
      docCategories,
      companies: { selectedCompany },
    } = this.props;
    let content;
    if (creationStep === 'uploadTemplate') {
      content =
      (
        <UploadTemplate
          onDrop={this.onDrop.bind(this)}
          onError={this.props.displayToaster}
          hasFile={!!file}
          loading={loading}
          selectedCompany={selectedCompany}
          groupedCategoryList={this.groupCategories(docCategories)}
          onClose={openConfirmDialogue => this.onClose(openConfirmDialogue)}
          values={values}
          errors={errors}
          touched={touched}
          functions={{
            getCategories: this.loadMoreCategories.bind(this),
          }}
        />
      );
    } else if (creationStep === 'templateType') {
      content =
      (
        <TemplateType
          selectedCompany={selectedCompany}
          // the user will always have entered data if they're in the help me choose modal, so we always want to open the onClose confirmation
          onClose={() => this.onClose(true)}
          updateButtonLabel={(newButtonText, newSubmittingText) => this.updateButtonLabel(newButtonText, newSubmittingText)}
          toggleHelpModal={close => this.toggleHelpModal(close)}
          updateTemplateTypeValue={newValue => this.updateTemplateTypeValue(newValue)}
          startingTemplateType={this.state.templateTypeValue}
        />
      );
    } else if (creationStep === 'helpMeChoose') {
      content = (
        <TemplateHelp
          // the user will always have entered data if they're in the help me choose modal, so we always want to open the onClose confirmation
          onClose={() => this.onClose(true)}
          toggleHelpModal={close => this.toggleHelpModal(close)}
          selectedCompany={selectedCompany}
          isDirectClient={isDirectClient}
        />
      );
    }
    return content;
  }

  resetTemplateState() {
    this.setState(DEFAULT_STATE);
  }

  render() {
    const {
      toggle,
      loading,
      createTemplateData,
      companies: { selectedCompany },
    } = this.props;
    const
      {
        buttonText,
        buttonTextUpdating,
        creationStep,
        uploadTemplateValues,
        file,
      } = this.state;
    const isSubmitting =
      loading[UPLOAD_COMPANY_DOCUMENT] === 'loading'
      || loading[UPLOAD_SIMPLE_SIGNATURE_REQUEST] === 'loading'
      || loading[GET_UPLOAD_URL] === 'loading';
    const companyIsSimpleSign = selectedCompany.esignatureProductTier.name === esignProductTierNames.SIMPLESIGN;
    const companyIsLegacy = selectedCompany.isEsignatureLegacyCompany;
    let modalMargin = '';
    let maxWidth;
    if (creationStep === 'helpMeChoose') {
      maxWidth = '760px';
      if (companyIsLegacy && companyIsSimpleSign) {
        modalMargin = 'small-margin';
      } else {
        modalMargin = 'medium-margin';
      }
    } else {
      modalMargin = 'large-margin';
      maxWidth = '600px';
    }

    return (
      <Fragment>
        <CenteredModal
          className={modalMargin}
          style={{ maxWidth }}
          isOpen={this.props.isOpen}
          parentselector={APPLICATION_ROOT}
          toggle={() => toggle()}
          backdrop="static"
        >
          <Formik
            initialValues={{ title: '' }}
            validateOnChange
            validateOnBlur
            validationSchema={creationStep === 'uploadTemplate' ? uploadSchema : null}
          >
            {({
                values,
                errors,
                touched,
              }) => (
                <Fragment>
                  <ExitConfirmationModal
                    closeConfirmationModal={quitTemplateCreation => this.closeConfirmationModal(quitTemplateCreation)}
                    confirmationModalIsOpen={this.state.confirmationModalIsOpen}
                  />
                  <ModalBody className="p-4" style={{ maxHeight: '95vh', overflowY: 'auto' }}>
                    {this.modalContent(values, errors, touched)}
                  </ModalBody>
                  {creationStep !== 'helpMeChoose' ?
                    <ModalFooter className="border-top-0 pr-4 pb-4">
                      <Button
                        className="mr-3"
                        color="default"
                    // we should open up the exit confirmation modal if any fields have been changed
                    // (we have to cast this as a Boolean for some reason)
                        onClick={() => this.onClose(Boolean(uploadTemplateValues || values.title || values.category || file))}
                      >
                        <FormattedMessage id="CANCEL" />
                      </Button>
                      <SubmitButton
                        className="ml-0"
                        onSubmit={() => this.onSubmit(values)}
                        defaultLabel={buttonText}
                        submittingLabel={buttonTextUpdating}
                        submitting={isSubmitting}
                        disabled={isSubmitting || !((uploadTemplateValues && uploadTemplateValues.title) || values.title) || (!file)}
                      />
                    </ModalFooter>
                :
                  null
                }
                </Fragment>
              )}
          </Formik>
        </CenteredModal>
        <HellosignContainer
          file={file}
          toggleHelloSignDrawer={this.toggleHelloSignDrawer.bind(this)}
          helloSignDrawerOpen={this.state.helloSignDrawerOpen}
          templateData={{ url: createTemplateData.template.editUrl, clientId: createTemplateData.clientId, id: createTemplateData.template.id }}
          uploadTemplateValues={uploadTemplateValues}
          resetTemplateState={this.resetTemplateState}
          openConfirmationDialog={() => this.setState({ confirmationModalIsOpen: true })}
        />
      </Fragment>
    );
  }
}

CreateTemplate.propTypes = {
  getCreateTemplateUrl: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  displayToaster: PropTypes.func.isRequired,
  isDirectClient: PropTypes.bool.isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  hideToaster: PropTypes.func.isRequired,
  getDocCategoryList: PropTypes.func.isRequired,
  pushRecentDocCategory: PropTypes.func.isRequired,
  docCategories: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })),
    recent: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })),
    next: PropTypes.string,
  }).isRequired,
  uploadCompanyDocument: PropTypes.func.isRequired,
  companies: PropTypes.shape({
    selectedCompany: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      esignatureProductTier: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
      isEsignatureLegacyCompany: PropTypes.bool,
    }),
  }).isRequired,
  createTemplateData: PropTypes.shape({
    clientId: PropTypes.string,
    template: PropTypes.shape({
      editUrl: PropTypes.string,
      id: PropTypes.string,
    }),
  }).isRequired,
  esignDocs: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      category: PropTypes.string,
      uploadDate: PropTypes.string,
      isEsignatureDocument: PropTypes.bool,
      isHelloSignTemplate: PropTypes.bool,
      fileName: PropTypes.string,
    })),
  }).isRequired,
  uploadSimpleSignatureRequest: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const {
      resources: {
        templates: {
          createTemplate,
        },
        docs: {
          docCategories,
          esignDocs,
        },
        companies,
      },
      appState,
    } = state;
    return {
      companies,
      esignDocs,
      loading: appState.loading,
      drawerIsOpen: appState.drawer.isOpen,
      isDirectClient: state.resources.tenants.isDirectClient,
      docCategories,
      createTemplateData: createTemplate,
    };
  },
  {
    getCreateTemplateUrl: (file, companyId, category, title) => getCreateTemplateUrl(file, companyId, category, title),
    displayToaster: args => displayToaster(...args),
    toggleDrawer: open => toggleDrawer(open),
    hideToaster: location => hideToaster(location),
    getDocCategoryList: next => getCompanyDocCategories(next),
    pushRecentDocCategory: category => pushRecentDocCategory(category),
    uploadCompanyDocument: (
      file,
      companyId,
      category,
      isPublishedToEmployee,
    ) => uploadCompanyDocument(file, companyId, category, isPublishedToEmployee),
    uploadSimpleSignatureRequest: (
      payload,
      companyId,
      category,
      isPrivate,
    ) => uploadSimpleSignatureRequest(payload, companyId, category, isPrivate),
  }
)(hot(module)(CreateTemplate));



// WEBPACK FOOTER //
// ./src/containers/CreateTemplate/CreateTemplate.jsx